import React, { useState, useEffect } from 'react';
import lineHeader from "../../assets/images/line-header.svg";
import calendrier from "../../assets/images/calendrier.svg";
import fleche from "../../assets/images/fleche.svg";
import {urlBase, urlDirectus} from "../../config/Globals";

function Diaporama({ newsData }) {

    const [currentIndex, setCurrentIndex] = useState(0);

    const nextNews = () => {
        setCurrentIndex((prevIndex) => {
            if (prevIndex >= newsData.length - 1) {
                return 0;
            }
            return prevIndex + 1;
        });
    };

    useEffect(() => {
        const timer = setInterval(nextNews, 5000);
        return () => clearInterval(timer);
    }, [currentIndex]);

    const handleButtonClick = (e) => {
        e.preventDefault();
        nextNews();
    };
    const currentNews = newsData[currentIndex];

    return (
        <div
            className="bloc-en-ce-moment-hero translate-x-hero-2 d-flex flex-column align-items-end align-items-lg-start align-items-xl-end">
            <div key={currentIndex} className="row g-0 position-relative card-news-overlap align-items-stretch">
                <div className="col-xl-8 bg-white p-4 p-md-5 d-flex text-center text-lg-start position-relative">
                    <img src={lineHeader} className="position-absolute d-none d-xl-block" alt=""
                         style={{width: 200, top: '25%', right: '95%'}}/>
                    <div className="p-xl-4 ps-xl-5 text-center text-lg-start">
                        <h2 className="display-6 fw-sb mb-4">En ce moment<br/>dans le vignoble</h2>
                        <div
                            className="d-flex align-items-center justify-content-center justify-content-lg-start gap-2 fs-5 mb-2 text-marron">
                            <img src={calendrier} alt="" className="object-fit-contain"/>
                            <span className="date-en-ce-moment anime-news1">{new Date(currentNews.date_actu).toLocaleDateString('fr-FR')}</span>
                        </div>
                        <p className="p-en-ce-moment anime-news2 fw-sb fs-4 lh-normal mb-lg-4">{currentNews.titre}</p>
                    </div>
                </div>
                <div className="col-xl-4 visuel-en-ce-moment-hero d-none d-xl-block">
                    <img src={urlDirectus+"assets/"+currentNews.image} alt={"Photo " + currentNews.titre} className="img-en-ce-moment w-100 h-100 object-fit-cover anime-news3"/>
                </div>

            </div>
            <div
                className="col-12 col-xl-11 ps-lg-5 ps-xxl-4 pt-4 pt-sm-5 d-flex flex-lg-column flex-xl-row align-items-center align-items-lg-start align-items-xl-center justify-content-between gap-5">
                <a onClick={handleButtonClick}
                   className="btn-en-ce-moment fs-5 fw-b d-none d-sm-flex text-black text-decoration-none gap-3 align-items-center ms-lg-5 ms-xl-2">Voir
                    plus <img src={fleche} alt=">" className="object-fit-contain"/></a>
                <a onClick={handleButtonClick}
                   className="btn-en-ce-moment fs-5 fw-b d-flex d-sm-none text-black text-decoration-none gap-3 align-items-center ms-lg-5 ms-xl-2">Plus <img
                    src={fleche} alt=">" className="object-fit-contain"/></a>
                <a href={urlBase + "en-ce-moment-dans-le-vignoble"} className="btn btn-violet ms-lg-5 ms-xl-0 d-none d-sm-inline-flex">Voir toutes les infos</a>
                <a href={urlBase + "en-ce-moment-dans-le-vignoble"} className="btn btn-violet ms-lg-5 ms-xl-0 d-sm-none">Voir tout</a>
            </div>
        </div>
)
    ;
}

export default Diaporama;